import httpClient from './httpClient';

const GetUserPermissions = (userId, companyId, propertyId, roleExcluded = false) => httpClient.get('/api/v2/Permission/UserPermissions', { params: { userId, companyId, propertyId, roleExcluded } });

const GetRolePermissions = (roleId) => httpClient.get('/api/v2/Permission/RolePermissions', { params: { roleId } });

const GetPermissionDatabaseVsSystem = () => httpClient.get('/api/v2/Permission/GetPermissionDatabaseVsSystem');

const UpdateUserPermission = (model) => httpClient.post('/api/v2/Permission/UpdateUserPermission', model);

const UpdateRolePermission = (model) => httpClient.post('/api/v2/Permission/UpdateRolePermission', model);

const GetPermissions = () => httpClient.get('/api/v2/Permission/Index');


export default {
  GetUserPermissions,
  UpdateUserPermission,
  GetPermissions,
  GetRolePermissions,
  UpdateRolePermission,
  GetPermissionDatabaseVsSystem
}



// WEBPACK FOOTER //
// ./src/api/permission-api.js